import request from "@/utils/request"

// 科室月度账单
export function deptMonthBill(query) {
  return request({
    url: `/db/bill-management/dept-month-bill`,
    method: 'get',
    params:query
  })
}

// 各科室月度账单报表
export function deptMonthBillReport(query) {
  return request({
    url: `/db/bill-management/dept-month-bill-report`,
    method:'get',
    params:query
  })
}

// 科室月度账单明细报表
export function deptMonthBillDetailReport(query) {
  return request({
    url: `/db/bill-management/dept-month-bill-detail-report`,
    method: 'get',
    params:query
  })
}


// 科室月度账单明细
export function deptMonthBillDetail(query) {
  return request({
    url: `/db/bill-management/dept-month-bill-detail`,
    method: 'post',
    params:query
  })
}